import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { blogAPI } from '../../services/api';
import { Pagination, EmptyState } from '../../components/common';

/* ── Blog list ───────────────────────────────────── */
export const BlogPage = () => {
  const [posts,  setPosts]  = useState([]);
  const [cats,   setCats]   = useState([]);
  const [meta,   setMeta]   = useState(null);
  const [page,   setPage]   = useState(1);
  const [catId,  setCatId]  = useState('');
  const [loading,setLoading]= useState(true);

  useEffect(()=>{
    blogAPI.categories().then(({data})=>setCats(data.data||[])).catch(()=>{});
  },[]);

  useEffect(()=>{
    setLoading(true);
    blogAPI.list({page,per_page:9,status:'published',category:catId||undefined})
      .then(({data})=>{setPosts(data.data||[]);setMeta(data.meta);})
      .catch(()=>{}).finally(()=>setLoading(false));
  },[page,catId]);

  return (
    <div style={{paddingTop:'var(--header-h)',minHeight:'100vh',background:'var(--bg-page)'}}>
      <div style={{background:'var(--brand-primary)',padding:'var(--space-2xl) 0 var(--space-xl)'}}>
        <div className="container">
          <h1 style={{color:'white',fontSize:'clamp(28px,4vw,44px)',fontWeight:800,marginBottom:'var(--space-sm)'}}>Nos réalisations</h1>
          <p style={{color:'rgba(255,255,255,.7)',fontSize:17}}>Découvrez nos créations, conseils et inspirations pour votre personnalisation textile.</p>
          <div style={{display:'flex',gap:8,flexWrap:'wrap',marginTop:'var(--space-lg)'}}>
            <button onClick={()=>{setCatId('');setPage(1);}} style={{padding:'6px 14px',borderRadius:'var(--radius-full)',fontWeight:600,fontSize:13,border:'1.5px solid rgba(255,255,255,.3)',color:'white',background:!catId?'var(--brand-accent)':'transparent',cursor:'pointer',transition:'all .2s'}}>Tous</button>
            {cats.map(c=>(
              <button key={c.id} onClick={()=>{setCatId(c.id);setPage(1);}} style={{padding:'6px 14px',borderRadius:'var(--radius-full)',fontWeight:600,fontSize:13,border:'1.5px solid rgba(255,255,255,.3)',color:'white',background:catId===c.id?'var(--brand-accent)':'transparent',cursor:'pointer',transition:'all .2s'}}>{c.name}</button>
            ))}
          </div>
        </div>
      </div>
      <div className="container" style={{padding:'var(--space-2xl) var(--space-lg)'}}>
        {loading ? <div className="page-loader"><div className="spinner spinner-lg"/></div> :
          !posts.length ? <EmptyState icon="📝" title="Aucun article" description="Revenez bientôt !" /> : (
            <>
              <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))',gap:'var(--space-md)'}}>
                {posts.map(p=>(
                  <Link key={p.id} to={`/blog/${p.slug}`} style={{display:'flex',flexDirection:'column',background:'var(--bg-card)',border:'1px solid var(--border)',borderRadius:'var(--radius-lg)',overflow:'hidden',textDecoration:'none',transition:'all .25s'}}>
                    {p.featured_image ? <img src={p.featured_image} alt={p.title} style={{width:'100%',height:200,objectFit:'cover'}}/> : <div style={{height:200,background:'var(--bg-page)'}}/>}
                    <div style={{padding:'var(--space-lg)',display:'flex',flexDirection:'column',gap:8,flex:1}}>
                      {p.category_name&&<span style={{fontSize:11,fontWeight:700,textTransform:'uppercase',letterSpacing:'0.5px',color:p.category_color||'var(--brand-accent)'}}>{p.category_name}</span>}
                      <h3 style={{fontSize:17,fontWeight:700,color:'var(--text-primary)',lineHeight:1.4}}>{p.title}</h3>
                      {p.excerpt&&<p style={{fontSize:14,color:'var(--text-secondary)',lineHeight:1.6,display:'-webkit-box',WebkitLineClamp:2,WebkitBoxOrient:'vertical',overflow:'hidden'}}>{p.excerpt}</p>}
                      <div style={{display:'flex',gap:12,fontSize:12,color:'var(--text-muted)',marginTop:'auto'}}>
                        <span>{p.first_name} {p.last_name}</span>
                        {p.published_at&&<span>{new Date(p.published_at).toLocaleDateString('fr-FR')}</span>}
                        {p.views>0&&<span>{p.views} vues</span>}
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
              <div style={{display:'flex',justifyContent:'center',padding:'var(--space-xl) 0'}}>
                <Pagination meta={meta} onPageChange={p=>{setPage(p);window.scrollTo(0,0);}}/>
              </div>
            </>
          )
        }
      </div>
    </div>
  );
};

/* ── Blog detail ─────────────────────────────────── */
export const BlogDetailPage = () => {
  const { slug }           = useParams();
  const [post, setPost]    = useState(null);
  const [loading,setLoading]=useState(true);

  useEffect(()=>{
    blogAPI.get(slug).then(({data})=>setPost(data.data)).catch(()=>{}).finally(()=>setLoading(false));
  },[slug]);

  if (loading) return <div style={{paddingTop:'var(--header-h)'}} className="page-loader"><div className="spinner spinner-lg"/></div>;
  if (!post)   return <div style={{paddingTop:'var(--header-h)',textAlign:'center',padding:'var(--space-3xl)'}}>Article introuvable.</div>;

  return (
    <div style={{paddingTop:'var(--header-h)',minHeight:'100vh'}}>
      {post.featured_image&&<div style={{height:'360px',overflow:'hidden',background:'var(--bg-page)'}}><img src={post.featured_image} alt={post.title} style={{width:'100%',height:'100%',objectFit:'cover'}}/></div>}
      <div className="container" style={{maxWidth:820,padding:'var(--space-2xl) var(--space-lg)'}}>
        <div style={{marginBottom:'var(--space-xl)'}}>
          {post.category_name&&<span style={{fontSize:12,fontWeight:700,textTransform:'uppercase',letterSpacing:'0.5px',color:post.category_color||'var(--brand-accent)',marginBottom:'var(--space-sm)',display:'block'}}>{post.category_name}</span>}
          <h1 style={{fontSize:'clamp(24px,4vw,42px)',fontWeight:800,lineHeight:1.2,marginBottom:'var(--space-md)'}}>{post.title}</h1>
          <div style={{display:'flex',gap:'var(--space-md)',flexWrap:'wrap',color:'var(--text-muted)',fontSize:14}}>
            <span>Par {post.first_name} {post.last_name}</span>
            {post.published_at&&<span>{new Date(post.published_at).toLocaleDateString('fr-FR',{day:'numeric',month:'long',year:'numeric'})}</span>}
            <span>{post.views} vues</span>
          </div>
        </div>

        {post.excerpt&&<p style={{fontSize:18,color:'var(--text-secondary)',lineHeight:1.7,borderLeft:'3px solid var(--brand-accent)',paddingLeft:'var(--space-md)',marginBottom:'var(--space-xl)',fontStyle:'italic'}}>{post.excerpt}</p>}

        <div style={{lineHeight:1.8,fontSize:16,color:'var(--text-secondary)'}} dangerouslySetInnerHTML={{__html:post.content}}/>

        {post.tags?.length>0&&(
          <div style={{marginTop:'var(--space-xl)',display:'flex',gap:8,flexWrap:'wrap'}}>
            {post.tags.map(tag=>(
              <span key={tag} style={{padding:'4px 12px',background:'var(--bg-page)',border:'1px solid var(--border)',borderRadius:'var(--radius-full)',fontSize:13,color:'var(--text-muted)'}}>{tag}</span>
            ))}
          </div>
        )}

        {post.related?.length>0&&(
          <div style={{marginTop:'var(--space-3xl)'}}>
            <h2 style={{fontSize:22,fontWeight:700,marginBottom:'var(--space-xl)'}}>Articles similaires</h2>
            <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(220px,1fr))',gap:'var(--space-md)'}}>
              {post.related.map(r=>(
                <Link key={r.id} to={`/blog/${r.slug}`} style={{background:'var(--bg-card)',border:'1px solid var(--border)',borderRadius:'var(--radius-lg)',overflow:'hidden',textDecoration:'none'}}>
                  {r.featured_image&&<img src={r.featured_image} alt={r.title} style={{width:'100%',height:140,objectFit:'cover'}}/>}
                  <div style={{padding:'var(--space-md)'}}>
                    <h4 style={{fontSize:14,fontWeight:700,color:'var(--text-primary)',lineHeight:1.4}}>{r.title}</h4>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
